export const _getFocusedColor = ({ error, isFocused, isHover, disabled }) => {
  if (disabled) return "fieldGray";
  else if (error) return "danger";
  else if (isFocused) return "primary";
  else if (isHover) return "tertiary";
  else return "fieldGray";
};

export const _getTextColor = ({ error, isFocused, isHover, disabled }) => {
  if (disabled) return "fieldGray";
  else if (error) return "danger";
  else if (isFocused) return "primary";
  else if (isHover) return "tertiary";
  else return "fieldGray";
};

export const _getBorderConfig = ({
  error,
  isFocused,
  isHover,
  disabled,
  input,
}) => {
  let ret = "";
  let lineStyle = "solid";
  if (disabled) lineStyle = "dashed";

  if (input === "textarea" || input === "slate") {
    ret += `border: ${
      (isHover || isFocused || error) && !disabled ? "2px" : "1px"
    } ${lineStyle};`;
    ret += `border-radius: 5px;`;
  } else {
    ret += `border-bottom: ${isHover ? "2px" : "1px"} ${lineStyle};`;
  }
  return ret;
};

export const _getLabelConfig = ({ input, isFocused, isFilled }) => {
  let ret = "";
  let zIndex = -1;
  let transform = `transform: ${
    isFocused || isFilled
      ? "translate3d(0px,5px,0px) scale(.75)"
      : "translate3d(0px, 30px, 0px)"
  };`;
  if (input === "slate" || input === "textarea") {
    zIndex = 1;
    transform = `transform: ${
      isFocused || isFilled
        ? "translate3d(10px,13px,0px) scale(.75)"
        : "translate3d(10px, 30px, 0px)"
    };`
  }
  ret += `z-index: ${zIndex};`;
  ret += transform;
  return ret;
};

